import { FC, useState, Fragment } from "react"

// types
import { SingleHrefLangMetaDataSet } from "../../../gatsby-node"

export const HrefLangTags: FC<{
  metaData: { [langCode: string]: SingleHrefLangMetaDataSet }
  shouldNoIndex: boolean
}> = ({ metaData, shouldNoIndex }) => {
  const [xDefaultDataSet, setXDefaultDataSet] =
    useState<SingleHrefLangMetaDataSet>()

  if (!metaData || Object.keys(metaData)?.length <= 0 || shouldNoIndex) {
    return null
  }

  return (
    <>
      {Object.values(metaData).map((data, index) => {
        const totalLen = Object.values(metaData)?.length
        const langCode = data?.hreflang?.toLowerCase()

        if (!xDefaultDataSet && langCode === "en-us") {
          setXDefaultDataSet(data)
        }

        if (data?.href && data?.hreflang) {
          return (
            <Fragment key={data?.href + "__" + data?.hreflang}>
              <link
                id={`${data?.rel}--${data?.href}`}
                rel={data?.rel ? data?.rel : "alternate"}
                href={data?.href}
                hrefLang={data?.hreflang}
              />

              {!xDefaultDataSet &&
                index + 1 === totalLen &&
                langCode === "en-us" && (
                  <link
                    id={`${data?.rel}--${data?.href}`}
                    rel={data?.rel ? data?.rel : "alternate"}
                    href={data?.href}
                    hrefLang="x-default"
                  />
                )}
              {xDefaultDataSet && index + 1 === totalLen && (
                <link
                  id={`${xDefaultDataSet?.rel}--${xDefaultDataSet?.href}`}
                  rel={
                    xDefaultDataSet?.rel ? xDefaultDataSet?.rel : "alternate"
                  }
                  href={xDefaultDataSet?.href}
                  hrefLang="x-default"
                />
              )}
            </Fragment>
          )
        }

        return null
      })}
    </>
  )
}
